﻿
const filter = {
    init() {
        const filtrationWrapper = document.querySelector("#filtrationWrapper");
				let filtrationClasses = ["container", "mx-auto", "filtration-parent"]

        if (filtrationWrapper === null) return

        this.filters = []
				
        filtrationWrapper.parentElement.classList.add(...filtrationClasses);

        this.items = document.querySelectorAll('.card__list--item')

        this.events()
    },

    events() {
        var inputs = document.getElementsByName('departmentName');
        var all = document.querySelector('#all')
        

        for (let i = 0; i < inputs.length; i++) {
            let input = inputs[i]

            input.addEventListener('click', (e) => {
                this.toggleFilter(e)
            })
        }

        all.addEventListener('click', (e) => {
            this.showAll(e)
        })
        
    },

    toggleFilter (e) {
        const target = e.currentTarget

        target.checked ? this.filters.push(target.value) : this.filters.splice(this.filters.indexOf(target.value), 1)
        

        this.toggleListItems()
    },

    showAll(e) {
        for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i]
            var show = true
            var unCheck = document.querySelectorAll('input:checked');
            

            if (show) {
                item.classList.add('show')
            } else {
                item.classList.remove('show')
            }

            for (var x = 0; x < unCheck.length; ++x) {
                unCheck[x].checked = false;
            }
				}

				for (let i = 0; i < inputs.length; i++) {
						let input = inputs[i]

						input.addEventListener('click', (e) => {
								this.toggleFilter(e)
						})
				}

        all.addEventListener('click', (e) => {
            this.toggleListItems(e)
        })
    },

    toggleListItems () {
        for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i]
            let departments = item.querySelectorAll('.department')
            var checked = document.querySelectorAll('input:checked');
            var show = false            

            for (let department of departments) {
                let value = department.innerHTML

                if (this.filters.indexOf(value) > -1) {
                    show = true
                }
            }

            if (checked.length === 0)  {
                var show = true
            }

            if (show) {
                item.classList.add('show')
            } else {
                item.classList.remove('show')
            }

            all.addEventListener('click', (e) => {
                this.showAll(e)
            })
        }
    }
}

export default filter.init()